import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { PaymentMethodResponse } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { paymentMethodService } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.service'

export const columnsDefPaymentMethodGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.typeOfPayment'),
            field: 'name',
            minWidth: 250,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export interface PaymentMethodGridState extends CrudModelPaginator<PaymentMethodResponse> {
    service: typeof paymentMethodService
}
export const initialPaymentMethodGridState =
    (): PaymentMethodGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.paymentMethods',
        columnsDef: columnsDefPaymentMethodGrid(),
        datasource: new PaginatorDatasource(paymentMethodService),
        service: paymentMethodService,
        visibleSidePanel: false
    })
